export const siteInfo = {
  name: '樱花动漫',
  fullName: '樱花动漫91',
  slogan: '下拉式阅读，沉浸式追漫',
  description: '樱花动漫91是国内领先的在线漫画阅读平台，采用创新的下拉式阅读模式，为您带来流畅无中断的漫画浏览体验。平台汇聚海量正版漫画资源，涵盖热血、恋爱、悬疑、搞笑、科幻、奇幻、日常等多种题材，每日更新最新漫画章节，让您随时随地免费阅读好看的漫画。无论您是资深漫迷还是刚入坑的新读者，樱花动漫91都能满足您的阅读需求。',
  stats: [
    { label: '日更新章节', value: '200+' },
    { label: '收录漫画', value: '30,000+' },
    { label: '累计读者', value: '800万+' },
  ],
};

export const aboutContent = {
  title: '关于樱花动漫',
  description: '樱花动漫91成立于2018年，致力于为中文漫画爱好者打造极致的在线阅读体验。我们首创下拉式漫画阅读模式，告别传统翻页的繁琐，让阅读如同瀑布般流畅自然。平台收录超过30,000部漫画作品，涵盖热血、恋爱、悬疑、搞笑、科幻、奇幻等全品类题材，每日同步更新200余章最新漫画内容。我们始终坚持免费阅读的理念，让每一位漫迷都能无障碍地享受漫画的乐趣。',
};

export const carouselItems = [
  {
    id: 1,
    tag: '热血推荐',
    title: '鬼灭之刃：无限列车篇完结纪念',
    description: '回顾灶门炭治郎与伙伴们在无限列车上的壮烈战斗，重温炼狱杏寿郎的炽热之魂。经典名场面一次看过瘾，热血与泪水交织的不朽篇章。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20anime%20illustration%20style%20scene%20of%20a%20brave%20warrior%20with%20a%20sword%20standing%20in%20front%20of%20a%20flaming%20train%2C%20dramatic%20lighting%2C%20orange%20and%20red%20warm%20tones%2C%20detailed%20character%20design%2C%20epic%20composition%2C%20soft%20gradient%20background%20with%20embers%20floating&width=800&height=500&seq=carousel-01&orientation=landscape',
    stat: '1.2亿阅读',
  },
  {
    id: 2,
    tag: '新番速递',
    title: '咒术回战：涩谷事变篇深度解析',
    description: '虎杖悠仁与两面宿傩的命运对决正式拉开帷幕，涩谷街头的惊天之战将彻底改变咒术界的格局。各方势力集结，最激烈的咒术大战一触即发。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20anime%20illustration%20of%20a%20young%20sorcerer%20with%20glowing%20energy%20surrounded%20by%20urban%20cityscape%20at%20night%2C%20mysterious%20purple%20and%20warm%20amber%20accents%2C%20dynamic%20action%20pose%2C%20cinematic%20lighting%2C%20clean%20background%20with%20subtle%20particles&width=800&height=500&seq=carousel-02&orientation=landscape',
    stat: '9800万阅读',
  },
  {
    id: 3,
    tag: '经典回顾',
    title: '海贼王：和之国篇巅峰之战全集',
    description: '路飞觉醒五档尼卡形态，与凯多的终极对决震撼登场！和之国百年恩怨即将画上句号，新时代的浪潮已经不可阻挡，一起见证历史性时刻。',
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20anime%20illustration%20of%20a%20pirate%20captain%20with%20a%20straw%20hat%20in%20a%20dynamic%20battle%20pose%2C%20traditional%20Japanese%20castle%20in%20background%2C%20vibrant%20warm%20colors%2C%20dramatic%20clouds%2C%20epic%20adventure%20atmosphere%2C%20cheerful%20yet%20powerful%20expression&width=800&height=500&seq=carousel-03&orientation=landscape',
    stat: '2.5亿阅读',
  },
  {
    id: 4,
    tag: '恋爱精选',
    title: '堀与宫村：青春恋爱物语特别篇',
    description: '看似完全不相配的两个人，却编织出最温暖甜蜜的校园恋爱故事。重温堀京子与宫村伊澄从相遇到相知的每一个心动瞬间，治愈系恋爱漫画的巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20romantic%20anime%20illustration%20of%20a%20high%20school%20couple%20under%20cherry%20blossom%20trees%2C%20warm%20pink%20and%20peach%20tones%2C%20gentle%20afternoon%20sunlight%2C%20school%20uniforms%2C%20shy%20smiles%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background&width=800&height=500&seq=carousel-04&orientation=landscape',
    stat: '6500万阅读',
  },
  {
    id: 5,
    tag: '悬疑烧脑',
    title: '约定的梦幻岛：逃出孤儿院完全解读',
    description: '艾玛、诺曼和雷发现孤儿院的残酷真相后，展开了一场惊心动魄的大逃亡。高智商的博弈、缜密的计划、令人窒息的紧张感，悬疑漫画不可错过的神作。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20illustration%20of%20children%20running%20through%20a%20dark%20forest%20with%20moonlight%2C%20suspenseful%20atmosphere%2C%20warm%20moonlight%20breaking%20through%20trees%2C%20detailed%20expressions%20of%20determination%2C%20gothic%20building%20silhouette%20in%20distance%2C%20soft%20ambient%20lighting&width=800&height=500&seq=carousel-05&orientation=landscape',
    stat: '8900万阅读',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《咒术回战》第二季制作决定PV',
    duration: '02:35',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=A%20thumbnail%20style%20anime%20illustration%20of%20a%20powerful%20sorcerer%20with%20white%20hair%20and%20a%20blindfold%2C%20cool%20expression%2C%20blue%20energy%20effects%2C%20cinematic%20composition%2C%20warm%20lighting%20accents%2C%20professional%20anime%20key%20visual%20style&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '漫画家专访：吾峠呼世晴创作幕后',
    duration: '15:20',
    views: '86万',
    image: 'https://readdy.ai/api/search-image?query=An%20interview%20style%20scene%20with%20drawing%20table%20and%20manga%20sketches%2C%20warm%20studio%20lighting%2C%20pens%20and%20paper%2C%20creative%20workspace%2C%20soft%20ambient%20light%2C%20cozy%20atmosphere%2C%20artist%20desk%20with%20tools&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '2024夏季新番导视：最值得追的10部',
    duration: '08:42',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20collage%20style%20anime%20illustration%20with%20multiple%20character%20silhouettes%2C%20summer%20theme%2C%20bright%20warm%20colors%2C%20festive%20atmosphere%2C%20gradient%20background%20with%20sunlight%2C%20cheerful%20vibe&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '漫画阅读技巧：下拉式阅读的正确姿势',
    duration: '05:18',
    views: '56万',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20reading%20scene%20with%20a%20tablet%20displaying%20manga%20pages%2C%20warm%20lamp%20light%2C%20comfortable%20chair%2C%20evening%20atmosphere%2C%20soft%20shadows%2C%20relaxing%20home%20environment%2C%20digital%20reading&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20avatar%20icon%20of%20a%20girl%20with%20short%20hair%2C%20warm%20expression%2C%20minimalist%20design%2C%20soft%20pastel%20colors%2C%20circular%20portrait%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '漫迷小樱',
    time: '2小时前',
    comic: '《鬼灭之刃》',
    content: '下拉式阅读真的太爽了！看打斗场面的时候一气呵成，完全不被打断，比翻页模式沉浸感强太多了。无限列车篇看得我哭了好几次，炼狱大哥永远的神！',
    likes: 2836,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20icon%20of%20a%20boy%20with%20glasses%2C%20friendly%20smile%2C%20minimalist%20design%2C%20warm%20colors%2C%20circular%20portrait%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '二次元阿杰',
    time: '5小时前',
    comic: '《咒术回战》',
    content: '每天都在等更新，樱花动漫的更新速度是真的快，基本上日本那边刚出这边就有了。涩谷篇每一话都在神展开，五条悟被封的那一刻我整个人都傻了。',
    likes: 1923,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20avatar%20icon%20of%20a%20girl%20with%20long%20hair%2C%20gentle%20smile%2C%20minimalist%20design%2C%20soft%20peach%20colors%2C%20circular%20portrait%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '追漫少女琳',
    time: '8小时前',
    comic: '《堀与宫村》',
    content: '画质清晰到每一根线条都看得清清楚楚，而且完全没有广告弹窗的困扰！堀与宫村这种细腻的恋爱漫画用下拉式看特别舒服，感情线发展流畅自然，甜到掉牙了。',
    likes: 1567,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20icon%20of%20a%20cool%20boy%20with%20spiky%20hair%2C%20slight%20smirk%2C%20minimalist%20design%2C%20warm%20orange%20accents%2C%20circular%20portrait%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '热血漫人',
    time: '12小时前',
    comic: '《海贼王》',
    content: '从学生时代看到现在工作，海贼王陪伴了我十年。樱花动漫的书架功能让我把所有追的漫画都整理得井井有条，再也不会忘记看到哪里了。和之国篇燃爆了！',
    likes: 3210,
  },
];

export const rankingItems = [
  { id: 1, rank: 1, trend: 'up', title: '鬼灭之刃', genre: '热血', heat: '🔥 1.2亿', chapter: '第205话' },
  { id: 2, rank: 2, trend: 'up', title: '咒术回战', genre: '战斗', heat: '🔥 9800万', chapter: '第248话' },
  { id: 3, rank: 3, trend: 'stable', title: '海贼王', genre: '冒险', heat: '🔥 2.5亿', chapter: '第1112话' },
  { id: 4, rank: 4, trend: 'up', title: '间谍过家家', genre: '喜剧', heat: '🔥 7200万', chapter: '第96话' },
  { id: 5, rank: 5, trend: 'down', title: '电锯人', genre: '黑暗', heat: '🔥 6500万', chapter: '第175话' },
];

export const topicItems = [
  { id: 1, name: '热血战斗', count: '12.5万', color: 'primary' },
  { id: 2, name: '恋爱校园', count: '9.8万', color: 'accent' },
  { id: 3, name: '悬疑推理', count: '7.2万', color: 'secondary' },
  { id: 4, name: '搞笑日常', count: '10.3万', color: 'primary' },
  { id: 5, name: '科幻未来', count: '5.6万', color: 'accent' },
  { id: 6, name: '奇幻异世界', count: '11.8万', color: 'secondary' },
  { id: 7, name: '恐怖惊悚', count: '4.2万', color: 'primary' },
  { id: 8, name: '运动竞技', count: '6.1万', color: 'accent' },
  { id: 9, name: '历史古风', count: '3.9万', color: 'secondary' },
  { id: 10, name: '治愈温情', count: '8.7万', color: 'primary' },
];

export const faqItems = [
  {
    id: 1,
    question: '樱花动漫91的漫画资源是否免费？',
    answer: '是的，樱花动漫91平台上的所有漫画资源均免费向读者开放。我们通过广告合作和会员增值服务来维持平台运营，不会对基础阅读功能收取任何费用。您可以随时随地免费阅读所有在线的漫画作品。',
  },
  {
    id: 2,
    question: '什么是下拉式漫画阅读模式？',
    answer: '下拉式阅读是我们平台的核心特色之一。与传统翻页模式不同，下拉式阅读将整话漫画内容纵向排列，您只需向下滑动屏幕即可连续阅读，无需点击翻页按钮。这种方式让阅读体验更加流畅自然，尤其适合战斗和动作场景的连贯呈现。',
  },
  {
    id: 3,
    question: '漫画更新频率是怎样的？',
    answer: '我们平台的漫画更新频率与日本原作连载同步，通常在原作更新后24小时内完成汉化并上线。热门连载漫画如《海贼王》《咒术回战》等基本能做到当天更新。平均每日新增更新章节超过200话。',
  },
  {
    id: 4,
    question: '如何在手机上获得最佳阅读体验？',
    answer: '樱花动漫91的网站采用了响应式设计，在手机浏览器中打开即可自动适配屏幕尺寸。下拉式阅读模式在手机端体验尤为出色，单手持握即可流畅浏览。我们也提供了App下载入口，App端支持离线下载和夜间模式等额外功能。',
  },
  {
    id: 5,
    question: '支持哪些漫画分类和题材？',
    answer: '平台涵盖热血、恋爱、悬疑、搞笑、科幻、奇幻、日常、运动、历史、恐怖等十余种漫画分类。无论您喜欢紧张刺激的战斗场面，还是温馨治愈的日常故事，都能在这里找到心仪的作品。我们还定期推出精选专题，帮助读者发现更多优质漫画。',
  },
  {
    id: 6,
    question: '如何联系平台或投稿建议？',
    answer: '您可以通过页面底部的「联系我们」模块发送反馈和建议。我们非常重视每一位读者的意见，运营团队会在收到反馈后的48小时内回复。如果您是漫画创作者，也欢迎通过该渠道与我们洽谈合作事宜。',
  },
];

export const appContent = {
  title: '随时随地，畅享下拉式阅读',
  description: '下载樱花动漫91 App，享受离线下载、夜间模式、更新提醒等专属功能。手机端下拉式阅读体验更流畅，单手操作也能轻松追漫。',
  features: ['离线下载', '夜间模式', '更新提醒', '高清画质'],
  image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20app%20interface%2C%20warm%20gradient%20background%2C%20modern%20UI%20design%2C%20Japanese%20manga%20style%20illustrations%20on%20screen%2C%20clean%20minimal%20device%20frame%2C%20soft%20lighting%2C%20premium%20app%20presentation&width=600&height=700&seq=app-01&orientation=portrait',
};

export const cardItems = [
  {
    id: 1,
    tag: '新番上线',
    title: '怪兽8号',
    description: '中年清洁工日比野卡夫卡意外获得变身怪兽的能力，为守护梦想与伙伴而战的科幻热血故事。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20illustration%20of%20a%20monster%20and%20a%20hero%20facing%20off%2C%20sci-fi%20theme%2C%20warm%20orange%20and%20red%20accents%2C%20dramatic%20composition%2C%20detailed%20character%20design%2C%20cinematic%20lighting%2C%20simple%20dark%20background&width=600&height=400&seq=card-01&orientation=landscape',
    stat: '日榜第1',
  },
  {
    id: 2,
    tag: '人气爆款',
    title: '间谍过家家',
    description: '间谍父亲、杀手母亲、超能力女儿组成的伪装家庭，爆笑与温情并存的日常喜剧。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20family%20anime%20illustration%20of%20a%20father%20mother%20and%20little%20girl%20with%20pink%20hair%2C%20cozy%20living%20room%20setting%2C%20cheerful%20expressions%2C%20soft%20peach%20and%20cream%20tones%2C%20heartwarming%20atmosphere%2C%20clean%20background&width=600&height=400&seq=card-02&orientation=landscape',
    stat: '周榜第2',
  },
  {
    id: 3,
    tag: '经典必读',
    title: '钢之炼金术师',
    description: '爱德华与阿尔冯斯兄弟为找回失去的一切，踏上寻找贤者之石的冒险旅程。等价交换的深刻主题震撼人心。',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20anime%20illustration%20of%20two%20brothers%20in%20adventure%20gear%2C%20one%20in%20armor%2C%20steampunk%20elements%2C%20warm%20golden%20and%20bronze%20tones%2C%20dramatic%20sky%2C%20journey%20theme%2C%20detailed%20background&width=600&height=400&seq=card-03&orientation=landscape',
    stat: '评分9.8',
  },
  {
    id: 4,
    tag: '编辑部推荐',
    title: '葬送的芙莉莲',
    description: '长寿精灵魔法使芙莉莲在勇者逝世后踏上理解人类的旅程，温暖而深沉的后勇者物语。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20anime%20illustration%20of%20an%20elf%20mage%20walking%20through%20a%20flowery%20meadow%2C%20warm%20sunset%20lighting%2C%20nostalgic%20atmosphere%2C%20soft%20pastel%20colors%2C%20gentle%20expression%2C%20peaceful%20landscape&width=600&height=400&seq=card-04&orientation=landscape',
    stat: '新晋神作',
  },
  {
    id: 5,
    tag: '话题热议',
    title: '电锯人',
    description: '贫困少年淀治与电锯恶魔波奇塔融合，以恶魔猎人的身份在残酷世界中生存的黑暗英雄谭。',
    image: 'https://readdy.ai/api/search-image?query=A%20gritty%20anime%20illustration%20of%20a%20blonde%20boy%20with%20chainsaw%20arms%20in%20an%20urban%20alley%2C%20dark%20atmosphere%2C%20warm%20red%20and%20orange%20splashes%2C%20dynamic%20action%2C%20rough%20texture%2C%20rebellious%20energy&width=600&height=400&seq=card-05&orientation=landscape',
    stat: '讨论1.2万',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    description: '创新的纵向连续阅读模式，告别翻页打断。阅读漫画如同瀑布般流畅，战斗场景一气呵成。',
  },
  {
    id: 2,
    icon: 'ri-timer-flash-line',
    title: '极速更新',
    description: '与日本连载同步更新，平均24小时内完成汉化上线。热门漫画当天更新，追更不等待。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '高清正版',
    description: '所有漫画资源均为高清画质，日漫原作授权汉化。清晰到每一根线条，还原漫画原本魅力。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    description: '响应式设计适配所有设备，手机、平板、电脑无缝切换。下拉式阅读在移动端体验更出色。',
  },
];

export const contactContent = {
  title: '联系我们',
  description: '无论是漫画推荐、使用反馈还是商务合作，我们都期待听到您的声音。樱花动漫91运营团队会在48小时内回复您的留言。',
  email: 'contact@yinghuadongman91.com',
  hours: '周一至周日 9:00 - 22:00',
};

export const indexItems = [
  { id: 1, name: '热血漫画', icon: 'ri-fire-line', count: '8,520部', description: '燃烧斗志的冒险与战斗，海贼王、鬼灭之刃等经典热血作品都在这里' },
  { id: 2, name: '恋爱漫画', icon: 'ri-heart-line', count: '6,340部', description: '从校园初恋到成人恋爱，甜到心坎里的纯爱故事与揪心的三角关系' },
  { id: 3, name: '搞笑漫画', icon: 'ri-emotion-laugh-line', count: '4,180部', description: '日常爆笑、无厘头喜剧，让您笑到停不下来的欢乐漫画合集' },
  { id: 4, name: '悬疑漫画', icon: 'ri-search-eye-line', count: '3,250部', description: '烧脑推理、惊悚反转，每一页都充满悬念的智斗神作等你来挑战' },
  { id: 5, name: '科幻漫画', icon: 'ri-rocket-line', count: '2,890部', description: '未来世界、人工智能、星际冒险，科幻迷的天堂级漫画图书馆' },
  { id: 6, name: '奇幻漫画', icon: 'ri-magic-line', count: '5,670部', description: '异世界转生、魔法冒险、剑与魔法的幻想世界，满足你的所有想象' },
  { id: 7, name: '日常漫画', icon: 'ri-sun-line', count: '3,960部', description: '温馨治愈的日常生活，轻松悠闲的阅读体验，平凡中的不平凡故事' },
];

export const updateItems = [
  { id: 1, date: '07-29', tag: '更新', title: '《咒术回战》第248话已更新', detail: '两面宿傩 vs 虎杖悠仁，最终决战正式打响' },
  { id: 2, date: '07-29', tag: '新作', title: '《怪兽8号》第112话火热上线', detail: '日比野卡夫卡身份暴露，防卫队紧急集结' },
  { id: 3, date: '07-28', tag: '更新', title: '《海贼王》第1112话同步上线', detail: '路飞五档全力爆发，贝加庞克的最终计划揭晓' },
  { id: 4, date: '07-28', tag: '活动', title: '夏季漫画阅读挑战赛开启', detail: '完成阅读任务赢取专属徽章和会员权益' },
  { id: 5, date: '07-27', tag: '更新', title: '《葬送的芙莉莲》第132话', detail: '芙莉莲与伙伴踏上新的旅程，勇者回忆篇完结' },
  { id: 6, date: '07-27', tag: '新作', title: '《胆大党》动画化纪念专题上线', detail: '回顾漫画经典名场面，绫濑桃与高仓健的奇妙冒险' },
  { id: 7, date: '07-26', tag: '公告', title: '樱花动漫91服务器全面升级完成', detail: '阅读加载速度提升40%，下拉式体验更加流畅丝滑' },
];

export const partners = {
  title: '合作伙伴',
  items: [],
};